import { Modal, message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';
import * as documentFunction from 'components/UIBuilder/SectionFunction/Document';
import moment from 'moment';

// Inspection Section 标题栏按钮：打开当前 Job 的 Inspection 汇总
export function showInspectionCategoryAuditing({ pageComponent } = {}) {
  pageComponent.inspectionCategoryAuditing.current?.open();
}

export function manageGroup({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageGroupShow: true });
  setTimeout(() => {
    sectionComponent.child.current?.manageGroup.current?.getSubJobGroupList();
  }, config.setTimeoutMilliSecond);
}

export function addSubJob({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (pageComponent.state.maxFreeInspectionExceed) {
    Modal.confirm({
      title: 'Alert',
      content: 'Max number of allowed inspections is reached.',
      transitionName: "",
      maskTransitionName: "",
      okCancel: false,
    });
  }

  sectionComponent.setState({ Notify: false, SubContractorId: 0, showModal: true, componentType: 'Create' });
  setTimeout(() => {
    let formData = parameter;
    //设置富文本的控件为空字符串，否则会崩
    formData['Directions'] = '';
    formData['MetaTypeId'] = 0;
    if (pageComponent.state.jobData.ModuleConfig.DefaultSubJobContractorId !== null) {
      formData['SubContractorId'] = pageComponent.state.jobData.ModuleConfig.DefaultSubJobContractorId;
    } else {
      formData['SubContractorId'] = 0;
    }

    // formData['ScheduledTime'] = [moment('06:00', 'HH:mm'), moment('12:00', 'HH:mm')];
    switch (pageComponent.state.jobData.ModuleConfig.SubJobDefaultTimeBlock) {
      case "AM":
        formData['ScheduledTimeAmPm'] = 0;
        break;
      case "PM":
        formData['ScheduledTimeAmPm'] = 1;
        break;
      case "Anytime":
        formData['ScheduledTimeAmPm'] = 2;
        break;
      case "Time Block":
        formData['ScheduledTimeAmPm'] = 3;
        break;
      default:
        formData['ScheduledTimeAmPm'] = 0;
        break;
    }
    scheduledTimeAmPmOnChange({ parameter: formData['ScheduledTimeAmPm'], sectionComponent: sectionComponent, pageComponent: pageComponent, sectionName: sectionName, uie: uie });
    let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
    sectionComponent.props.section.componentList.filter(c => c.type === 'Create')[0].groupList.forEach(group => {
      group.uieList.forEach(uie => {
        switch (uie.component) {
          case 'Select':
            let selectValue = null;
            if (componentDataSource[uie.source] !== undefined) {
              if (uie.type === 'group') {
                componentDataSource[uie.source].some(group => {
                  if (group.SelectOptionList === null) {
                    selectValue = group.Value;
                    return true;
                  }
                  return group.SelectOptionList.some(selectOption => {
                    selectValue = selectOption.Value;
                    return true;
                  });
                });
              } else {
                if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                  selectValue = componentDataSource[uie.source][0].Value;
                }
                if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                  selectValue = [];
                }
              }
            }
            if (componentDataSource[uie.source] !== undefined) {
              sectionComponent.customForm.current?.formRef.current?.setFieldValue(uie.source, selectValue);
            }
            break;
        }
      });
    });

    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData, currentDataKey: 0 });

    setTimeout(() => {
      //设置联动的Select
      getSubJobGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, jobId: pageComponent.state.jobData.JobId });
      addSubJobPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

//弹出添加DIV后触发
export function addSubJobPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (pageComponent.state.jobData.CompanyId == 3 && pageComponent.state.jobData.CompanyOfficeName != 'Approvable') {
    checkDN({ parameter, sectionComponent, pageComponent, sectionName, uie });
  }
}

//弹出编辑DIV后触发
export function editSubJobPopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (pageComponent.state.jobData.CompanyId == 3 && pageComponent.state.jobData.CompanyOfficeName != 'Approvable') {
    checkDN({ parameter, sectionComponent, pageComponent, sectionName, uie });
  }
  sectionComponent.customForm.current?.setState({ activeKey: 0 });
  sectionComponent.setState({
    Notify: false,
    ScheduledDate: moment(sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate')).format(config.format.sqlDate),
    SubContractorId: sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId'),
  });
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'OralDirectionAddTask', sectionComponent.customForm.current?.formRef.current?.getFieldValue('OralDirectionIssueDate') !== undefined);
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'WrittenDirectionAddTask', sectionComponent.customForm.current?.formRef.current?.getFieldValue('WrittenDirectionIssueDate') !== undefined);
  setTimeout(() => {
    getSubContractor({ sectionName, parameter, formComponent: sectionComponent.customForm.current, sectionComponent, pageComponent, uie });
    //设置联动的Select
    getSubJobGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, jobId: pageComponent.state.jobData.JobId });
  }, config.setTimeoutMilliSecond * 20);
}

function checkDN({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    const element = document.querySelector('.InspectionAlertText');
    let approvalComponent = globalFunction.getSectionComponent(pageComponent, 'Approval');
    if (approvalComponent.child?.current?.state?.data?.some(item => item.ApprovalTypeMetaType === 5)) {
      if (element && !element.classList.contains('display-none')) {
        element.classList.add('display-none');
      }
    } else {
      if (element && element.classList.contains('display-none')) {
        element.classList.remove('display-none');
      }
    }
  }, config.setTimeoutMilliSecond * 100);
}

export function getSubJobComponentDataSourceGroupRun({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  setTimeout(() => {
    getSubContractor({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie });
  }, config.setTimeoutMilliSecond * 20);
}

function getSubContractor({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let subContractorId = sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId');
  if (subContractorId !== undefined && subContractorId !== null && subContractorId !== 0) {
    let componentDataSource = { ...sectionComponent.customForm.current?.state.componentDataSource };
    let internalUserList = componentDataSource['SubContractorId']?.find(item => item.Key === 'Internal User');
    let externalContractorsList = componentDataSource['SubContractorId']?.find(item => item.Key === 'External Contractors');

    let has = false;
    if (internalUserList !== undefined && !has) {
      has = internalUserList.SelectOptionList.some(option => option.Value === subContractorId);
    }
    if (externalContractorsList !== undefined && !has) {
      has = externalContractorsList.SelectOptionList.some(option => option.Value === subContractorId);
    }

    if (!has) {
      httpClient
        .get('/Admin/CompanyUser/' + subContractorId)
        .then(({ data }) => {
          if (data.result) {
            const newOption = {
              Color: null,
              Value: subContractorId,
              Key: data.data.Name
            };
            if (data.data.ExternalContractor == true) {
              let componentDataSource = { ...sectionComponent.customForm.current?.state.componentDataSource };
              externalContractorsList = componentDataSource['SubContractorId']?.find(item => item.Key === 'External Contractors');
              has = externalContractorsList.SelectOptionList.some(option => option.Value === subContractorId);
              if (externalContractorsList !== undefined && !has) {
                externalContractorsList.SelectOptionList.push(newOption);
              }
              sectionComponent.customForm.current?.setState({ componentDataSource });
            } else {
              let componentDataSource = { ...sectionComponent.customForm.current?.state.componentDataSource };
              internalUserList = componentDataSource['SubContractorId']?.find(item => item.Key === 'Internal User');
              has = internalUserList.SelectOptionList.some(option => option.Value === subContractorId);
              if (internalUserList != undefined && !has) {
                internalUserList.SelectOptionList.push(newOption);
              }
              sectionComponent.customForm.current?.setState({ componentDataSource });
            }

          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }
  }
}

///获取当前Group列表
export function getSubJobGroupSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie, jobId } = {}) {
  httpClient
    .get('Business/SubJobGroup/GetSelectOptionList?jobId=' + jobId)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        componentDataSource['GroupId'] = dataSource;
        formComponent.setState({ componentDataSource });
        if (parameter.GroupId === undefined || parameter.GroupId === null) {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('GroupId', dataSource[0].Value);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//快速填充OralDirectionExpiryDate
export function quickAddDays_OralDirectionExpiryDate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let date = sectionComponent.customForm.current?.formRef.current?.getFieldValue('OralDirectionIssueDate');
  if (date !== undefined) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('OralDirectionExpiryDate', globalFunction.addDateMoment(date, parameter));
    globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'OralDirectionAddTask', true);
  }
}

//OralDirectionExpiryDate改变时触发
export function oralDirectionExpiryDateChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'OralDirectionAddTask', true);
}

//OralDirectionExpiryDate清空时触发
export function clearOralDirectionExpiryDate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'OralDirectionAddTask', false);
}

//快速填充WrittenDirectionExpiryDate
export function quickAddDays_WrittenDirectionExpiryDate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let date = sectionComponent.customForm.current?.formRef.current?.getFieldValue('WrittenDirectionIssueDate');
  if (date !== undefined) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('WrittenDirectionExpiryDate', globalFunction.addDateMoment(date, parameter));
    globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'WrittenDirectionAddTask', true);
  }
}

//WrittenDirectionExpiryDate改变时触发
export function writtenDirectionExpiryDateChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'WrittenDirectionAddTask', true);
}

//WrittenDirectionExpiryDate清空时触发
export function clearWrittenDirectionExpiryDate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'WrittenDirectionAddTask', false);
}

//编辑提交后可能会刷新Task
export function editSubmitFinish({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  globalFunction.getSectionComponent(pageComponent, 'JobTask')?.getSectionDataByDefault();
  globalFunction.getSectionComponent(pageComponent, 'Approval')?.getSectionDataByDefault();
}

//弹出mailmerge的div
export function docMergeSubJob({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.SubJobId, mailMergeObj: parameter, dataModelType: 2 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(2, parameter.SubJobId);
  }, config.setTimeoutMilliSecond);
}

// 发送检查记录通知
export function notifyRecipient({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  if (globalFunction.isNullOrEmpty(parameter.ResultOptionName)) {
    message.warning('This inspection has no result.');
    return;
  }

  const recipient = pageComponent.state.jobData?.ModuleConfig?.InspectionRecordNotificationReceipient;
  if (globalFunction.isNullOrEmpty(recipient)) {
    message.warning('No recipient configured.');
    return;
  }

  Modal.confirm({
    title: 'Notify Recipient',
    content: 'Send the inspection record notification to the configured recipients?',
    okText: 'Notify',
    cancelText: 'Cancel',
    transitionName: '',
    maskTransitionName: '',
    onOk: () => httpClient
      .post(pageComponent.props.areaName + '/' + sectionName + '/NotifyRecipient/' + parameter.SubJobId)
      .then(({ data }) => {
        if (data.result) {
          message.success('Inspection record notification sent.');
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch((error) => globalFunction.handleError(error, pageComponent))
  });
}

//设置是否发信
export function setNotify({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let notify = sectionComponent.customForm.current?.formRef.current?.getFieldValue('Notify');
  if (notify !== true) {
    sectionComponent.setState({ Notify: true });
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('Notify', true);
  } else {
    sectionComponent.setState({ Notify: false });
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('Notify', false);
  }
}

//检查时间是否有重合
function checkOverlap(startDate1, endDate1, startDate2, endDate2) {
  const start1Timestamp = startDate1.getTime();
  const end1Timestamp = endDate1.getTime();
  const start2Timestamp = startDate2.getTime();
  const end2Timestamp = endDate2.getTime();
  return (start2Timestamp < end1Timestamp && start1Timestamp < end2Timestamp);
}

//判断当前编辑的SubJob Result是否为Cancelled
export function isResultCancelled(sectionComponent) {
  let resultOptionId = sectionComponent.customForm.current?.formRef.current?.getFieldValue('ResultOptionId');
  if (resultOptionId === undefined || resultOptionId === null || resultOptionId === 0) {
    return false;
  }
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  let resultOptionList = componentDataSource?.ResultOptionId;
  if (!resultOptionList) {
    return false;
  }
  let option = resultOptionList.find(c => c.Value === resultOptionId);
  return option?.Key === 'Cancelled';
}

//特殊处理一些提交的条件
export function submitCustomForm({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let subContractorId = sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId');
  let scheduledDate = sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate');

  //JobDetail 编辑 Inspection 时, 如果 Result=Cancelled, 先校验 Inspection 名称不为空
  //若同时改了时间或Inspector, 先走原本的 Booking/Notify 弹框, 操作完成后再弹出取消通知框
  let needCancelInspectionNotification = pageComponent.props.pageName === 'JobDetail'
    && sectionComponent.state.componentType === 'Edit'
    && isResultCancelled(sectionComponent);
  if (needCancelInspectionNotification) {
    let inspectionName = sectionComponent.customForm.current?.formRef.current?.getFieldValue('Name');
    if (inspectionName === undefined || inspectionName === null || inspectionName.toString().trim() === '') {
      message.error('Inspection name cannot be empty.');
      return false;
    }
  }

  if (scheduledDate !== undefined) {
    let error = false;
    let errorCompanyUserNotAvailability = null;
    let scheduledTime = sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledTime');
    {
      // 如果没有填写scheduledTime，默认使用06:00-17:00作为时间范围
      let startTime = (scheduledTime !== undefined && scheduledTime !== null) ? moment(scheduledTime[0]).format('HH:mm') : '06:00';
      let endTime = (scheduledTime !== undefined && scheduledTime !== null) ? moment(scheduledTime[1]).format('HH:mm') : '17:00';

      let scheduledDateStart = new Date(moment(scheduledDate).format(config.format.sqlDate) + ' ' + startTime);
      let scheduledDateEnd = new Date(moment(scheduledDate).format(config.format.sqlDate) + ' ' + endTime);
      if (subContractorId !== 0) {
        let subContractor = sectionComponent.customForm.current.state.componentDataSource.SubContractorId.flatMap(item => item.SelectOptionList || []).find(option => option.Value === subContractorId);
        if (subContractor?.Data?.length > 0) {
          subContractor.Data.map((companyUserNotAvailability, i) => {
            // Parse StartDate and EndDate
            let startDate = new Date(moment(moment(companyUserNotAvailability.StartDate, 'DD/MM/YYYY HH:mm')).format('YYYY-MM-DD HH:mm'));
            let endDate = new Date(moment(moment(companyUserNotAvailability.EndDate, 'DD/MM/YYYY HH:mm')).format('YYYY-MM-DD HH:mm'));
            // Check if current date is between StartDate and EndDate
            let isDateBetween = checkOverlap(startDate, endDate, scheduledDateStart, scheduledDateEnd);
            if (isDateBetween) {
              error = true;
              errorCompanyUserNotAvailability = companyUserNotAvailability;
            }
          });

          if (error) {
            message.error(subContractor.Key + ' is not available between ' + errorCompanyUserNotAvailability.StartDate + ' and ' + errorCompanyUserNotAvailability.EndDate);
            return false;
          }
        }
      }

      if (pageComponent.state.subJobBlockDates !== null && pageComponent.state.subJobBlockDates !== undefined) {
        pageComponent.state.subJobBlockDates.map((subJobBlockDate, i) => {
          // Parse StartDate and EndDate
          let startDate = new Date(moment(subJobBlockDate).format('YYYY-MM-DD 00:00'));
          let endDate = new Date(moment(subJobBlockDate).format('YYYY-MM-DD 23:59'));
          // Check if current date is between StartDate and EndDate
          let isDateBetween = checkOverlap(startDate, endDate, scheduledDateStart, scheduledDateEnd);
          if (isDateBetween) {
            error = true;
            errorCompanyUserNotAvailability = { StartDate: moment(subJobBlockDate).format('DD/MM/YYYY 00:00'), EndDate: moment(subJobBlockDate).format('DD/MM/YYYY 23:59') }
          }
        });

        if (error) {
          message.error('The inspection date is blocked between ' + errorCompanyUserNotAvailability.StartDate + ' and ' + errorCompanyUserNotAvailability.EndDate);
          return false;
        }
      }
    }
  }

  //JobDetail 检查项
  if (pageComponent.props.pageName === 'JobDetail' && ((sectionComponent.state.ScheduledDate !== moment(sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate')).format(config.format.sqlDate) ||
    sectionComponent.state.SubContractorId !== sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId')) &&
    sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate') !== undefined &&
    sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId') !== 0)) {

    //触发Booking动作
    if (!checkSubJobBooking({ parameter, sectionComponent, pageComponent, sectionName, uie })) {
      //有未完成的检查
      sectionComponent.child.current?.setState({ subJobBookingAlertShow: true });
    } else {
      //没有未完成的检查，再检测是否发Notify
      if (sectionComponent.state.Notify !== true) {
        sectionComponent.child.current?.setState({ submitConfirmShow: true });
      } else if (needCancelInspectionNotification) {
        //时间/Inspector都已处理完, Result=Cancelled 时再弹取消通知框
        sectionComponent.child.current?.setState({ cancelInspectionNotificationShow: true });
      } else {
        sectionComponent.customForm.current?.submitForm();
      }
    }
  } else if (needCancelInspectionNotification) {
    //未改动时间/Inspector, 直接弹取消通知框
    sectionComponent.child.current?.setState({ cancelInspectionNotificationShow: true });
  } else if (pageComponent.props.pageName === 'InspectionScheduler' && ((sectionComponent.state.ScheduledDate !== moment(sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate')).format(config.format.sqlDate) ||
    sectionComponent.state.SubContractorId !== sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId')) &&
    sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate') !== undefined &&
    sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId') !== 0)) {

    if (sectionComponent.state.Notify !== true) {
      sectionComponent.child.current?.setState({ submitConfirmShow: true });
    } else {
      sectionComponent.customForm.current?.submitForm();
    }
  } else {
    sectionComponent.customForm.current?.submitForm();
  }
}

function checkSubJobBooking({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let result = true;

  //判断是否要开启提示
  if (pageComponent.state.jobData?.ModuleConfig?.SubJobBookingAlert === true) {
    //获取当前操作的SubJob
    let currentSubJob = sectionComponent.customForm.current?.formRef.current?.getFieldsValue();
    let currentSubJobId = sectionComponent.customForm.current?.state.currentDataKey;

    //找当前SubJob操作的Group
    let subJobGroup = sectionComponent.child.current?.state.data.find(item => item.SubJobGroupId == currentSubJob.GroupId);
    //找到了Group，说明以前有别的SubJob数据
    if (subJobGroup !== undefined) {
      let previousSubJob = null;
      if (currentSubJobId === 0) {
        //添加，找所有的条目
        subJobGroup.SubJobList.map(item => {
          if (item.ResultOptionId === null || item.ResultOptionName === 'Not Approved') {
            result = false;
          }
        })
      } else {
        //修改，找当前条前面的
        let index = subJobGroup.SubJobList.findIndex(subJob => subJob.SubJobId === currentSubJobId);
        for (let i = 0; i < index; i++) {
          if (subJobGroup.SubJobList[i].ResultOptionId === null || subJobGroup.SubJobList[i].ResultOptionName === 'Not Approved') {
            result = false;
          }
        }
      }

      // 如果找到上一条，则进行判断
      if (previousSubJob !== null) {
        if (previousSubJob.ResultOptionId === null || previousSubJob.ResultOptionName === 'Not Approved') {
          result = false;
        }
      }
    }
  }
  return result;
}

//InspectionScheduler 上的编辑
export function editByInspectionScheduler({ parameter, sections, sectionComponent, pageComponent, sectionName, uie } = {}) {
  //先获取数据
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/GetDetailWidthJob/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.setState({ showModal: true, componentType: 'Edit', renderForm: true });
        let recordData = data.data;

        //通过这条数据的 Job_ModuleId 获取控件数据源
        httpClient
          .get(sectionComponent.customForm.current?.props.component.datasourceUrl + '?moduleId=' + data.data.Job_ModuleId + '&jobId=' + recordData.JobId)
          .then(({ data }) => {
            if (data.result) {
              if (data.data.length > 0) {
                data.data.map((hash, i) => {
                  let dataSource = hash.Value;
                  let uie = null;
                  sectionComponent.customForm.current?.props.component.groupList.map((group, j) => {
                    group.uieList.map((u, k) => {
                      if (u.source == hash.Key) {
                        uie = u;
                      }
                    })
                  })
                  if (uie !== null) {
                    let componentDataSource = { ...sectionComponent.customForm.current?.state.componentDataSource };
                    if (uie.required) {
                      dataSource = dataSource.filter(item => item.Value !== 0);
                    }
                    componentDataSource[hash.Key] = dataSource;
                    sectionComponent.customForm.current?.setState({ componentDataSource });
                  }
                });

                sectionComponent.customForm.current?.setState({ currentDataKey: recordData.key });
                //处理不适合antd组件的数据
                let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
                sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
                  group.uieList.forEach(uie => {
                    switch (uie.component) {
                      case 'DatePicker':
                        //处理日期, 把字符串转成moment
                        if (recordData[uie.source] !== null) {
                          recordData[uie.source] = moment(recordData[uie.source], config.format.date);
                        } else {
                          recordData[uie.source] = undefined;
                        }
                        break;
                      case 'TimePicker':
                        if (uie.component === 'TimePicker') {
                          switch (uie.type) {
                            case 'RangePicker':
                              if (recordData[uie.source] !== null && recordData[uie.source] !== undefined && !globalFunction.isNullOrEmpty(recordData[uie.source])) {
                                let time = recordData[uie.source].split(',').map(item => {
                                  if (item !== null && item !== undefined) {
                                    return moment(item, 'HH:mm');
                                  } else {
                                    return undefined;
                                  }
                                });
                                recordData[uie.source] = time;
                              } else {
                                recordData[uie.source] = undefined;
                              }
                              break;
                            default:
                              if (recordData[uie.source] !== null && recordData[uie.source] !== undefined) {
                                recordData[uie.source] = moment(recordData[uie.source], 'HH:mm');
                              } else {
                                recordData[uie.source] = undefined;
                              }
                              break;
                          }
                        }
                        break;
                      case 'Select':
                        //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                        if ((recordData[uie.source] === null || recordData[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                          recordData[uie.source] = componentDataSource[uie.source][0].Value;
                        }
                        if (uie.autoSelect) {
                          //如果是自定义AutoSelect的类型, 触发其onChange事件
                          operationalFunction({ functionName: uie.onChange, sectionName: sectionName, parameter: recordData[uie.source], formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, uie: uie });
                        }
                        break;
                      case 'RichTextEditor':
                        //处理RichTextEditor, 如果是null或者undefined，改为空字符串，否则会崩溃
                        if (recordData[uie.source] === null) {
                          recordData[uie.source] = '';
                        }
                        break;
                      case 'Input':
                        //处理Input, 如果type是fileName, 处理成改文件名的状态
                        if (uie.type === 'fileName') {
                          uie.addonAfter = globalFunction.getExtension(recordData[uie.source]);
                          recordData[uie.source] = globalFunction.getFileNameWithoutExtension(recordData[uie.source]);
                        }
                        break;
                    }
                  });
                });
                //把处理后的数据赋值给表单
                pageComponent.setState({ cutoffHours: recordData.Job.ModuleConfig.SubJobBookingCutoffHours, cutoffMinutes: recordData.Job.ModuleConfig.SubJobBookingCutoffMinutes });
                sectionComponent.customForm.current?.formRef.current?.setFieldsValue(recordData);
                sectionComponent.customForm.current?.setState({ formData: recordData });

                try {
                  sectionComponent.customForm.current?.setState({ activeKey: 0 });
                  sectionComponent.setState({
                    Notify: false,
                    ScheduledDate: moment(sectionComponent.customForm.current?.formRef.current?.getFieldValue('ScheduledDate')).format(config.format.sqlDate),
                    SubContractorId: sectionComponent.customForm.current?.formRef.current?.getFieldValue('SubContractorId')
                  });
                  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'OralDirectionAddTask', sectionComponent.customForm.current?.formRef.current?.getFieldValue('OralDirectionIssueDate') !== undefined);
                  globalFunction.setUieVisible(pageComponent, 'SubJob', 'Edit', 'WrittenDirectionAddTask', sectionComponent.customForm.current?.formRef.current?.getFieldValue('WrittenDirectionIssueDate') !== undefined);
                  setTimeout(() => {
                    getSubContractor({ sectionName, parameter, formComponent: sectionComponent.customForm.current, sectionComponent, pageComponent, uie });
                    //设置联动的Select
                    getSubJobGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent, jobId: recordData.JobId });
                  }, config.setTimeoutMilliSecond);
                } catch (error) { }
              }
            } else {
              globalFunction.handleResultError(data, pageComponent);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, pageComponent);
          });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//通过模板设置 Direction
export function setDirectionFromTemplate({ parameter, sections, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (parameter > 0) {
    httpClient
      .get('/Admin/SubJobDirectionTemplate/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          let directions = formComponent.formRef.current?.getFieldValue('Directions');
          directions = data.data.Direction + directions;
          formComponent.formRef.current?.setFieldValue('Directions', directions);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//打开从模板添加界面
export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let defaultFormData = pageComponent.state.defaultFormData;
  defaultFormData.moduleId = pageComponent.state.moduleId;
  pageComponent.setState({ defaultFormData });
  openAddFromTemplate({ component: sectionComponent.child.current, groupId: parameter?.GroupId });
}

export function openAddFromTemplate({ component, groupId } = {}) {
  component.setState({ addFromTemplateShow: true });
  component.addFromTemplate.current?.setState({ activeKey: 0, groupId });
  setTimeout(() => {
    component.addFromTemplate.current?.formRef.current?.resetFields();
    component.addFromTemplate.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], subJobTypePresetContentList: [] });
    setTimeout(() => {
      component.addFromTemplate.current?.additionalFormRef.current?.child.current?.getSubJobTypeData();
      component.addFromTemplate.current?.getSubJobTypePresetDataSource();
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

export function uploadReport({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let documentComponent = globalFunction.getSectionComponent(pageComponent, 'Document');
  documentFunction.addBySection({ sectionComponent: documentComponent, pageComponent: pageComponent });
  pageComponent.setState({ uploadType: 'SubJobReport', subJobId: parameter.key });
  setTimeout(() => {
    documentComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('DocumentTypeId', 0);
    documentComponent.child.current?.uploadDocument.current?.formRef.current?.setFieldValue('JobDocumentFolderId', 0);
  }, config.setTimeoutMilliSecond);
}

//删除SubJobReport
export function deleteSubJobReport({ parameter, sections, formComponent, sectionComponent, pageComponent, sectionName, uie } = {}) {
  httpClient
    .post('/Business/SubJob/DeleteSubJobReport/', parameter)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//Inspection Name 快速选择
export function nameOnChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  parameter = parameter.replace(/#/g, '');
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&moduleId=' + pageComponent.state.moduleId)
      .then(({ data }) => {
        let options = [];
        if (data.result) {
          data.data.map((subJobType, j) => {
            options.push({ label: subJobType.Name, value: subJobType.Name, data: subJobType });
          })
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    let componentDataSource = { ...formComponent.state.componentDataSource };
    componentDataSource[uie.source] = [];
    formComponent.setState({ componentDataSource });
  }
}

//Inspection Name 选择后快速填写数据
export function nameOnSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  formComponent.formRef.current?.setFieldValue('MetaTypeId', data.data.SubJobMetaTypeId !== null ? data.data.SubJobMetaTypeId : 0);

  if (sectionComponent.state.componentType === 'Create') {
    let templateId = data.data.SubJobInternalNoteTemplateId !== null && data.data.SubJobInternalNoteTemplateId !== undefined ? data.data.SubJobInternalNoteTemplateId : 0;
    formComponent.formRef.current?.setFieldValue('SubJobInternalNoteTemplateId', templateId);
    if (templateId > 0) {
      httpClient
        .get('/Admin/SubJobInternalNoteTemplate/' + templateId)
        .then(({ data }) => {
          if (data.result) {
            formComponent.formRef.current?.setFieldValue('Notes', data.data.Content);
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }
  }
}

export function inspectionToday({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.child.map((section, i) => {
    if (section.current?.props.parameter.name === 'SubJob') {
      section.current?.state.section.componentList[0].topButtonList[0].buttonList.map((item, i) => {
        item.className = null;
        if (uie !== undefined && item.onClick === uie.onClick) {
          item.className = 'dashboard-button-active';
        } else if (item.onClick === parameter) {
          item.className = 'dashboard-button-active';
        }
      })

      let searchParameter = { ...section.current?.state.searchParameter };
      searchParameter.Type = 'Today';
      section.current?.setState({ searchParameter });

      setTimeout(() => {
        section.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function inspectionTomorrow({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.child.map((section, i) => {
    if (section.current?.props.parameter.name === 'SubJob') {
      section.current?.state.section.componentList[0].topButtonList[0].buttonList.map((item, i) => {
        item.className = null;
        if (uie !== undefined && item.onClick === uie.onClick) {
          item.className = 'dashboard-button-active';
        } else if (item.onClick === parameter) {
          item.className = 'dashboard-button-active';
        }
      })

      let searchParameter = { ...section.current?.state.searchParameter };
      searchParameter.Type = 'Tomorrow';
      section.current?.setState({ searchParameter });

      setTimeout(() => {
        section.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function scheduledTimeAmPmOnChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  switch (parameter) {
    case 0:
      sectionComponent.customForm.current?.formRef.current?.setFieldValue('ScheduledTime', [moment('08:00', 'HH:mm'), moment('12:00', 'HH:mm')]);
      break;
    case 1:
      sectionComponent.customForm.current?.formRef.current?.setFieldValue('ScheduledTime', [moment('12:00', 'HH:mm'), moment('17:00', 'HH:mm')]);
      break;
    case 2:
      sectionComponent.customForm.current?.formRef.current?.setFieldValue('ScheduledTime', [moment('08:00', 'HH:mm'), moment('17:00', 'HH:mm')]);
      break;
    case 3:
      if (sectionComponent.componentType === 'Create') {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('ScheduledTime', undefined);
      }
      break;
  }
}

//Copy
export function copySubJob({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  uie.icon = 'loading.svg'
  httpClient
    .post(pageComponent.props.areaName + '/' + sectionName + '/Copy', parameter)
    .then(({ data }) => {
      if (data.result) {
        uie.icon = 'copy.svg'
        sectionComponent.getSectionDataByDefault();
      } else {
        uie.icon = 'copy.svg'
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      uie.icon = 'copy.svg'
      globalFunction.handleError(error, pageComponent);
    });
}

export function scheduledDateOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.customForm.current?.formRef.current?.setFieldValue('BookingUserId', pageComponent.props.authUser.CompanyUserId);
}

//Site Contact 快速选择
export function siteContactNameOnChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter.length >= config.component.AutoComplete.minimumQueryCharacters && !uie.autoDataSource && uie.datasourceUrl !== null) {
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + parameter + '&jobId=' + formComponent.props.jobId)
      .then(({ data }) => {
        if (data.result) {
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = data.data;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    let componentDataSource = { ...formComponent.state.componentDataSource };
    componentDataSource[uie.source] = [];
    formComponent.setState({ componentDataSource });
  }
}

//Site Contact 选择后快速填写数据
export function siteContactNameOnSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  const siteContactMobile = data.data.Mobile?.trim() || data.data.Phone?.trim() || '';
  formComponent.formRef.current?.setFieldsValue({ SiteContactName: data.data.FullName, SiteContactMobile: siteContactMobile, SiteContactEmail: data.data.Email !== null ? data.data.Email : '' });
}

export function formatData({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  setTimeout(() => {
    pageComponent.showMaxFreeInspection();
  }, config.setTimeoutMilliSecond);
}

export function subContractorOnChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  const divElement = document.getElementById('SubContractorNoteDiv');
  const element = document.getElementById('SubContractorNote');
  if (parameter > 0) {
    httpClient
      .get('/Admin/CompanyUser/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          if (!globalFunction.isNullOrEmpty(data.data.Note)) {
            if (divElement) {
              divElement.style.display = 'flex';
            }
            if (element) {
              element.innerHTML = data.data.Note?.replace(/\n/g, '<br />');
            }
          } else {
            if (divElement) {
              divElement.style.display = 'none';
            }
            if (element) {
              element.innerHTML = '';
            }
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    if (divElement) {
      divElement.style.display = 'none';
    }
    if (element) {
      element.innerHTML = '';
    }
  }
}

export function internalNoteFromTemplate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter > 0) {
    httpClient
      .get('/Admin/SubJobInternalNoteTemplate/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          formComponent.formRef.current?.setFieldValue('Notes', data.data.Content);
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function assignInspector({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ submitNotifyShow: true, Key: parameter.key, SubContractorId: parameter.subContractorId });
}
